import { render } from "./CleanProductsModal.vue?vue&type=template&id=25b9541b"
import script from "./CleanProductsModal.vue?vue&type=script&lang=js"
export * from "./CleanProductsModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\jm.loc\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__